'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { useVolunteerRegistrationSheet } from '../../organisms/volunteer-registration-sheet/volunteer-registration-sheet.logic.ts';
import { type VolunteerSlot, getSlotGroupKey } from '../../utils/volunteer-utils.ts';
import { getSlotCardAlertType, getSlotCardDisplayData } from '../slot-card/slot-card.logic.ts';
import { SlotCard } from '../slot-card/slot-card.tsx';
type Logic = ReturnType<typeof useVolunteerRegistrationSheet>;
export interface ShiftSlotItemProps {
  slot: VolunteerSlot;
  logic: Logic;
}
export const ShiftSlotItem: React.FC<ShiftSlotItemProps> = t0 => {
  const $ = _c(32);
  const {
    slot,
    logic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== logic.assignments || $[2] !== logic.contacts || $[3] !== logic.previousRegistrations || $[4] !== logic.sameDayRegistrations || $[5] !== logic.selectedContacts || $[6] !== logic.slotGroupIds || $[7] !== logic.slots || $[8] !== slot) {
    t2 = getSlotCardDisplayData({
      slot,
      allSlots: logic.slots,
      assignments: logic.assignments,
      slotGroupIds: logic.slotGroupIds,
      previousRegistrations: logic.previousRegistrations,
      selectedContacts: logic.selectedContacts,
      allContacts: logic.contacts,
      sameDayRegistrations: logic.sameDayRegistrations
    });
    $[1] = logic.assignments;
    $[2] = logic.contacts;
    $[3] = logic.previousRegistrations;
    $[4] = logic.sameDayRegistrations;
    $[5] = logic.selectedContacts;
    $[6] = logic.slotGroupIds;
    $[7] = logic.slots;
    $[8] = slot;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const display = t2;
  let t3;
  if ($[10] !== logic || $[11] !== slot.id) {
    t3 = assignedContactIds => {
      logic.setSlotAssignments(slot.id, assignedContactIds);
    };
    $[10] = logic;
    $[11] = slot.id;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleSave = t3;
  let t4;
  if ($[13] !== logic.duplicateShiftGroupKeys || $[14] !== logic.formErrors || $[15] !== logic.fullShiftGroupKeys || $[16] !== logic.sameDayShiftGroupKeys || $[17] !== slot) {
    const groupKey = getSlotGroupKey(slot);
    t4 = getSlotCardAlertType({
      groupKey,
      formErrors: logic.formErrors,
      fullShiftGroupKeys: logic.fullShiftGroupKeys,
      duplicateShiftGroupKeys: logic.duplicateShiftGroupKeys,
      sameDayShiftGroupKeys: logic.sameDayShiftGroupKeys
    });
    $[13] = logic.duplicateShiftGroupKeys;
    $[14] = logic.formErrors;
    $[15] = logic.fullShiftGroupKeys;
    $[16] = logic.sameDayShiftGroupKeys;
    $[17] = slot;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const alertType = t4;
  let t5;
  if ($[19] !== display.label || $[20] !== t) {
    t5 = display.label || t("volunteers:registration.shift");
    $[19] = display.label;
    $[20] = t;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== alertType || $[23] !== display.assignedContacts || $[24] !== display.contacts || $[25] !== display.disabled || $[26] !== display.remaining || $[27] !== display.timeDisplay || $[28] !== display.total || $[29] !== handleSave || $[30] !== t5) {
    t6 = <SlotCard timeDisplay={display.timeDisplay} label={t5} remaining={display.remaining} total={display.total} assignedContacts={display.assignedContacts} disabled={display.disabled} contacts={display.contacts} variant={alertType} onSave={handleSave} />;
    $[22] = alertType;
    $[23] = display.assignedContacts;
    $[24] = display.contacts;
    $[25] = display.disabled;
    $[26] = display.remaining;
    $[27] = display.timeDisplay;
    $[28] = display.total;
    $[29] = handleSave;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};